import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import AppRouter from "./AppRoutes";
import "@/i18n";
import { BrowserRouter } from "react-router-dom";
import { queryClient } from "@/shared/lib/queryClient";
import CardVideoMiniPlayer from "@/cards/common/component/background-players/mini-players/CardVideoMiniPlayer";
import CardAudioMiniPlayer from "@/cards/common/component/background-players/mini-players/CardAudioMiniPlayer";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#111111" },
    secondary: { main: "#c62828" },
    text: {
      primary: "#111111",
      secondary: "#575757",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Lexend", sans-serif',
    allVariants: {
      color: "inherit",
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
          <CssBaseline />
          <BrowserRouter>
            <AppRouter />
            <CardVideoMiniPlayer />
            <CardAudioMiniPlayer />
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
